import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { HashRouter, Routes, Route } from 'react-router-dom';
import AuthDialog from './components/AuthDialog';
import TourForm from './components/TourForm';
import { AuthProvider } from './contexts/AuthContext';
import Dashboard from './pages/Dashboard';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FF6B6B',
    },
    secondary: {
      main: '#4ECDC4',
    },
  },
});

function App() {
  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<TourForm />} />
              <Route path="/tour/:tourSlug" element={<TourForm />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>
            <AuthDialog />
          </div>
        </AuthProvider>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;
